import { render, staticRenderFns } from "./MdCustomModule.vue?vue&type=template&id=dd35fdd8&scoped=true&"
import script from "./MdCustomModule.vue?vue&type=script&lang=js&"
export * from "./MdCustomModule.vue?vue&type=script&lang=js&"
import style0 from "./MdCustomModule.vue?vue&type=style&index=0&id=dd35fdd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd35fdd8",
  null
  
)

export default component.exports